import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Settings } from 'lucide-react';
interface DesignQuestionScreenProps {
  onYes: () => void;
  onNo: () => void;
  onBack: () => void;
}
export function DesignQuestionScreen({
  onYes,
  onNo,
  onBack
}: DesignQuestionScreenProps) {
  return <div className="relative w-full h-screen overflow-hidden bg-slate-900" data-id="element-222">
      {/* Background */}
      <div className="absolute inset-0 z-0" data-id="element-223">
        <img src="https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1920&q=80" alt="Interior background" className="w-full h-full object-cover opacity-20 blur-sm" data-id="element-224" />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/90 to-slate-900/70" data-id="element-225" />
      </div>

      {/* Header - Higher z-index */}
      <div className="absolute top-6 left-6 right-6 z-50 flex items-center justify-between" data-id="element-226">
        <button onClick={onBack} className="flex items-center gap-2 text-white/70 hover:text-white transition-colors" data-id="element-227">
          <ArrowLeft className="w-5 h-5" data-id="element-228" />
          <span className="text-sm" data-id="element-229">Back</span>
        </button>
        <button className="p-3 rounded-full bg-slate-800/50 backdrop-blur-sm border border-white/10 hover:bg-slate-700/50 transition-colors" data-id="element-230">
          <Settings className="w-6 h-6 text-white" data-id="element-231" />
        </button>
      </div>

      {/* Content */}
      <div className="relative z-10 flex items-center justify-center h-full" data-id="element-232">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5
      }} className="bg-slate-800/80 backdrop-blur-xl rounded-2xl p-12 border border-white/10 shadow-2xl max-w-2xl" data-id="element-233">
          <h2 className="text-2xl text-white/80 text-center mb-8 uppercase tracking-wider" data-id="element-234">
            Have you designed your dream home
            <br data-id="element-235" />
            with Landmark Homes?
          </h2>

          <div className="flex items-center justify-center gap-6" data-id="element-236">
            <button onClick={onYes} className="px-12 py-4 bg-gradient-to-r from-cyan-600 to-cyan-500 hover:from-cyan-500 hover:to-cyan-400 text-white font-medium text-lg rounded-lg transition-all uppercase tracking-wider shadow-lg" data-id="element-237">
              Yes
            </button>
            <button onClick={onNo} className="px-12 py-4 bg-gradient-to-r from-cyan-600 to-cyan-500 hover:from-cyan-500 hover:to-cyan-400 text-white font-medium text-lg rounded-lg transition-all uppercase tracking-wider shadow-lg" data-id="element-238">
              No
            </button>
          </div>
        </motion.div>
      </div>
    </div>;
}